'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MGFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-k08tld9ea", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-k08tld9ea)" }, /* @__PURE__ */ React.createElement("path", { fill: "#78d843", d: "M12 12h20v12H12z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ea1a1a", d: "M12 0h20v12H12z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h12v24H0z" })))
  );
}

export { MGFlag };
//# sourceMappingURL=MG.mjs.map
